import React, { useCallback } from "react";
import { NarrowFilter, PopulationFilter, LinksList } from "../../../components";
import { useHistory } from "react-router-dom";
import { setQueryString, getQueryParam } from "../../../util/queryParamUtils";
import qs from "qs";
import { FilterContainer } from "./_.styled";
import { useSearch } from "../../../hooks/useSearch";
import { baseSearchTransform } from "../../../hooks/useBaseSearchTransform";
import ExcludedContentMessage from "../../../components/ExcludedContentMessage";

const POPULATION_ALL = "All";
const DROPDOWN_ITEMS = ["All", "Pediatric", "Adult"];

const FilterList = ({ data, label, excludedContent }) => {
  const history = useHistory();
  const initialSearchKey = qs.parse(history.location.search, {
    ignoreQueryPrefix: true,
  }).searchKey;
  const {
    searchTerm: searchKey,
    handleSearchTermChange: handleSearchKeyChange,
    searchUtils,
  } = useSearch(initialSearchKey);

  const [filteredPopulationData, setFilteredPopulationData] = React.useState();
  const [populationSelectedItem, setPopulationSelectedItem] = React.useState();

  const filterData = useCallback(
    (data, population) => {
      const customPredicate =
        population !== POPULATION_ALL
          ? (item) => item.population?.includes(population)
          : null;
      return baseSearchTransform({ items: data, searchUtils, customPredicate });
    },
    [searchUtils]
  );

  const handlePopulationFilterChange = (_index, fieldTitle) => {
    setPopulationSelectedItem(fieldTitle);
    setFilteredPopulationData(filterData(data, fieldTitle));
  };

  // Apply filter when URL with query string is directly accessed
  React.useEffect(() => {
    const populationTypeFilterQSValue = getQueryParam(
      history,
      "populationType"
    );
    const currentDropdownIndex = populationTypeFilterQSValue
      ? DROPDOWN_ITEMS.indexOf(populationTypeFilterQSValue)
      : 0;

    setPopulationSelectedItem(DROPDOWN_ITEMS[currentDropdownIndex]);

    if (data && populationTypeFilterQSValue) {
      setFilteredPopulationData(filterData(data, populationTypeFilterQSValue));
    }
  }, [data, history, filterData]);

  // set the query string in the url when the searchKey changes
  React.useEffect(() => {
    const populationTypeValue =
      populationSelectedItem && populationSelectedItem !== "All"
        ? populationSelectedItem
        : undefined;
    setQueryString(
      history,
      ["searchKey", searchKey || undefined],
      ["populationType", populationTypeValue]
    );
  }, [searchKey, populationSelectedItem, history]);

  const items =
    filteredPopulationData ||
    baseSearchTransform({ items: data || [], searchUtils });

  const excludedContentMessage = excludedContent?.message;
  const excludedLabels = excludedContent?.labels;
  const shouldShowExcludedContentMessage =
    excludedContentMessage && excludedLabels.includes(label);

  return (
    <>
      {shouldShowExcludedContentMessage ? (
        <ExcludedContentMessage message={excludedContentMessage} />
      ) : (
        <>
          <FilterContainer>
            <NarrowFilter value={searchKey} onChange={handleSearchKeyChange} />
            {data &&
              new Set(data.flatMap((item) => item.population)).size > 1 && (
                <PopulationFilter
                  options={DROPDOWN_ITEMS}
                  handleChange={handlePopulationFilterChange}
                />
              )}
          </FilterContainer>{" "}
          {!!(data && items.length) && (
            <LinksList
              items={items}
              noDataText="No matches for the term provided"
            />
          )}
        </>
      )}
    </>
  );
};

export default FilterList;
